export function OverViewIcon(props: React.SVGProps<SVGSVGElement>) {
return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
            stroke="#F04E23" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.5 6.66699H13.3333" stroke="#F04E23" stroke-width="1.66667" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M6.66666 10H11.6667" stroke="#F04E23" stroke-width="1.66667" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M9.16666 13.333H13.3333" stroke="#F04E23" stroke-width="1.66667" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
    )
}